<template>
	<div id="roles" class="page">
		<datatable
			model="roles"
			modal="Role"
		>
		</datatable>
		<router-view />
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datatable from '../components/Elements/Datatable'

export default {
  name: 'Roles',
  data () {
    return {
      //
    }
  },
  components: {
    Datatable
  },
  computed: {
    //
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ])
  },
  created () {
    this.setPageTitle('Roles')
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Roles.vue